export default __webpack_public_path__ + "static/media/greenTick.14a729bd.svg";